// Standard CSI MasterFormat division numbers -> titles, for the CostCodePicker's
// "Browse" tree (grouping CostCodes rows by Division the way OST's Condition
// Properties dialog browses its own type catalog by CSI division). Reference
// data only — CostCodes itself remains the source of truth for which codes
// actually exist; this just labels the group headers.
export const CSI_DIVISIONS = {
  0: "Procurement and Contracting Requirements",
  1: "General Requirements",
  2: "Existing Conditions",
  3: "Concrete",
  4: "Masonry",
  5: "Metals",
  6: "Wood, Plastics, and Composites",
  7: "Thermal and Moisture Protection",
  8: "Openings",
  9: "Finishes",
  10: "Specialties",
  11: "Equipment",
  12: "Furnishings",
  13: "Special Construction",
  14: "Conveying Equipment",
  21: "Fire Suppression",
  22: "Plumbing",
  23: "Heating, Ventilating, and Air Conditioning",
  25: "Integrated Automation",
  26: "Electrical",
  27: "Communications",
  28: "Electronic Safety and Security",
  31: "Earthwork",
  32: "Exterior Improvements",
  33: "Utilities",
  34: "Transportation",
  35: "Waterway and Marine Construction",
  40: "Process Interconnections",
  41: "Material Processing and Handling Equipment",
  42: "Process Heating, Cooling, and Drying Equipment",
  43: "Process Gas and Liquid Handling, Purification, and Storage Equipment",
  44: "Pollution and Waste Control Equipment",
  45: "Industry-Specific Manufacturing Equipment",
  46: "Water and Wastewater Equipment",
  48: "Electrical Power Generation",
};

export function divisionLabel(division) {
  if (division == null) return "Uncategorized";
  const name = CSI_DIVISIONS[division];
  return name ? `${String(division).padStart(2, "0")} — ${name}` : `Division ${division}`;
}
